module.exports = __webpack_public_path__ + "static/img/irole.ac95e63.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/oo/irole.png
// module id = A4zw
// module chunks = 7